import { render, staticRenderFns } from "./AdvertisingComponent.vue?vue&type=template&id=28a1bb70"
import script from "./AdvertisingComponent.vue?vue&type=script&lang=js"
export * from "./AdvertisingComponent.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingComponent.vue?vue&type=style&index=0&id=28a1bb70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports